module.exports = __webpack_public_path__ + "img/outline_bg_wap_2025_04_25.79729b16.png";